import React, { InputHTMLAttributes, ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { IOptions } from '../../types/IOptions';
import InformationTag from '../InfoTag/InfoTag';

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  itemNumber?: number;
  register: UseFormRegisterReturn;
  labelName?: ReactNode;
  fieldName: string | "field";
  infoTagMessage?: string | " ";
  errors?: Record<string, any>; // Form state errors
  options: IOptions[];
}

const RadioField: React.FC<RadioProps> = ({ register, labelName, fieldName, errors, options, infoTagMessage, itemNumber, ...rest }) => {
  return (

    <div className="relative z-0 w-full mb-10 group mb-6">
        <div className="flex">
            { itemNumber !== 0 &&                 
                    <div className="flex-none w-5 text-sm">{itemNumber}.</div>                
            }            
            <div className="text-sm grid grid-cols-2"><div>{labelName}</div> <div className="ml-2"><InformationTag message={infoTagMessage} /></div></div>
        </div>
        <div className="flex">
            <div className="flex-none w-5"></div>
            <div className="grow mt-3">
                    {options.map((option, index) => {
                        return (
                            <div className="flex items-center mb-2" key={index}>
                                <input 
                                    type="radio" 
                                    value={option.id} 
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                    {...rest}
                                    {...register}
                                />
                                <label className="ms-2 text-xs text-gray-900 dark:text-gray-300">{option.value}</label>
                            </div>
                        )
                    })}  
                {errors && errors[fieldName] && (
                    <div className="text-red-500 text-xs pt-2">{errors[fieldName].message}</div>
                )}
            </div>
        </div>
    </div>
  );
};

export default RadioField;